import React, { useEffect, useMemo } from "react"
import { debounce } from "lodash"
import { makeStyles } from "@mui/styles"

// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { MuiIcon } from "@cirrus/ui-kit/src/components/atoms/mui-icon/index.js"
import { TextField } from "@cirrus/ui-kit/src/components/atoms/text-field/index.js"
import { useTableContext } from "../../provider"
import { getSearchValue, setSearchValue } from "../../helpers"

const useStyles = makeStyles({
  searchField: {
    "& *:hover, & *:focus, & *:active, & *": {
      background: "transparent !important",
    },

    "& input": {
      fontSize: "12px !important",
    },

    "&:hover": {
      borderBottom: "none !important"
    },

    "&.MuiFilledInput-root:before": {
      borderBottom: "none !important"
    },

    "& .MuiInputBase-root": {
      width: "150px"
    },

    borderBottom: "none !important"
  }
})

export const SearchField = ({ placeholder = null }: {placeholder: string | null}) => {
  const ctx = useTableContext()
  const { searchDisabled, searchPlaceholder } = ctx.props
  const { setValue } = ctx.search.api

  const setValueHandler = (value: string) => {
    setValue(value)
    setSearchValue(value)
  }

  const search = useMemo(() => (
      !searchDisabled
        ? debounce(setValueHandler, 300)
        : debounce(() => {}, 300)
    ),
    [searchDisabled])

  const { searchField } = useStyles()

  useEffect(() => {

    return () => search && search.cancel()
  }, [])

  if (searchDisabled) return null

  return (
    <TextField
      background="transparent"
      className={searchField}
      placeholder={searchPlaceholder || i18n("General:Search")}
      startAdornment={<MuiIcon.Search />}
      onChange={(event) => {
        search(event.target.value)
      }}
      onClick={(event) => {
        event.stopPropagation()
      }}
      defaultValue={getSearchValue()}
    />
  )
}
